import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const usePageTracker = () => {
  const location = useLocation();
  const tracked = useRef(new Set());

  useEffect(() => {
    const key = location.pathname;
    if (tracked.current.has(key)) return;
    tracked.current.add(key);

    // Fire and forget, don't block rendering
    axios.post(`${API}/analytics/track`, { page: key, event: "view" }).catch(() => {});
  }, [location.pathname]);
};

// Track custom events (clicks on products, downloads, etc.)
export const trackEvent = (page, event) => {
  axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, { page, event }).catch(() => {});
};

export default usePageTracker;
